/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const exportEntries = {
  exportToCsv: 'Exportar a CSV',
  exportMessage:
    'El archivo CSV se descargará automáticamente en su dispositivo, si no es así, verifique la configuración de su navegador',
  columnNombres: {
    code: 'Código',
    quantity: 'Cantidad',
    name: 'Nombre',
    price: 'Precio',
  },
  exportProductToCsv: 'Exportar producto a CSV',
};

export const importEntries = {
  importProducts: 'Importar Carrito',
};

export const importEntriesDialog = {
  fileUploaded: 'Entradas importadas con éxito',
  importProducts: 'Importar Carrito',
  importProductsRulesTitle: 'Importar productos a sus carros guardados desde un archivo .xlsx',
  importProductsFirstRule: 'Cantidad, Tipo de Paquetes, Peso, Grupo, Calidad, Dimensione, Certificados',
  importProductsSecondRule: 'Tamaño máximo del archivo: 976 KB',
  importProductsSubtitle: 'El archivo importado se utilizará para crear un carrito nuevo que podrá consultar en la Sección de Mi cuenta / Carritos Guardados.',
  importProductFileDetails:
    'Seleccione el archivo a cargar. Primero deberá descargar el fichero a completar: ',
  importProductClickHere: 'Clic aquí',
  importProductFileDetailsFinal: 'para descargar archivo',
  importProductsNewSavedCartSubtitle:
    'Agregue productos importando un archivo . Archivo CSV.and creating a new saved cart.',
  selectFile: 'Seleccionar archivo',
  savedCartNombre: 'Número de carrito guardado',
  savedCartDescription: 'Descripción del carrito guardado',
  opcional: 'opcional',
  charactersLeft: 'Caracteres a la izquierda: {{count}}',
  cancel: 'Cancelar',
  upload: 'Subir',
  close: 'Cerrar',
  summary: {
    info: 'No cierre ni actualice esta ventana mientras se importan los productos.',
    loadedToCart: 'Los productos se han cargado en el carrito {{ cartName }}',
    loaded: 'Los productos han sido cargados',
    loading: 'Products are being processed... ({{ count }}/{{ total }})',
    successes:
      '{{ successesCount }} de {{ total }} los productos se han importado con éxito.',
    warning: '{{ count }} El producto no se importó en su totalidad.',
    warning_other: '{{ count }} Los productos no fueron importados en su totalidad.',
    error: '{{ count }} El producto no fue importado.',
    error_other: '{{{ count }} Los productos no fueron importados.',
    messages: {
      unknownIdentifier: 'Product SKU "{{ productCode}}" does not exist.',
      lowStock:
        'Cantidad para {{ productName }}: {{ quantity }} se ha reducido a {{ quantityAdded }}.',
      noStock: '{{ productName }} está actualmente agotado.',
      unknownError: 'Unrecognized problem with "{{ productCode }}".',
      limitExceeded: 'Can not add "{{ productCode }}". Limit exceeded.',
    },
    show: 'Mostrar',
    hide: 'Esconder',
  },
};

export const importExport = {
  exportEntries,
  importEntries,
  importEntriesDialog,
};
